import { get } from './client';

/**
 * 
 * @param {*} id 
 * @returns 
 */
export function getOneNetwork(id) {
    return get('network/' + id)
}
